import { useState } from 'react'

import { Box, Chevron, CollapsableCard, Text } from '@factorialco/deprecated-design-system'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { PendingCardPayment as PendingCardPaymentType } from 'modules/banking/hooks/usePendingCardPayments'
import { formattedAmount } from 'modules/banking/lib/paymentHelpers'

import { PendingCardPayment } from './PendingCardPayment'

interface Props {
  cardPayment: PendingCardPaymentType
}
export const PendingCardPaymentTransactionCard = ({ cardPayment }: Props) => {
  const {
    company: { locale },
  } = useCurrentSession()
  const amount = formattedAmount({
    amountCents: cardPayment.amountCents,
    currency: cardPayment.currency,
    locale: locale || '',
  })
  const [open, setOpen] = useState(false)
  return (
    <CollapsableCard
      open={open}
      Card={
        <Box flexDirection="row" justifyContent="spaceBetween" onClick={() => setOpen(!open)}>
          <Text weight="medium" size="300" color="grey800">
            {amount}
          </Text>
          <Box justifyContent="center">
            <Chevron type={'primary'} direction={open ? 'up' : 'down'}></Chevron>
          </Box>
        </Box>
      }
      Content={<PendingCardPayment cardPayment={cardPayment} />}
    />
  )
}
